import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeEventFilter, setUserInfo, setInfoForDashboard, logoutUser } from '../../actions';
import MALogo from '../../components/LoginForm/MALogo';
import WelcomeHeader from '../../components/Dashboard/WelcomeHeader';
import NewRequestButton from '../../components/Dashboard/NewRequestButton';
import BuyNowOption from '../../components/Dashboard/BuyNowOption';
import CredentialsSummary from '../../components/Credentials/CredentialsSummary';
import Events from '../../components/Events';
import '../../../html/assets/stylesheets/theme.scss';
import '../../../html/assets/stylesheets/sprites/ico-sprite.scss';

class Dashboard extends Component {

  componentDidMount() {
    this.props.setUserInfo();
    this.props.setInfoForDashboard();
  }

  render() {
    const {firstName, events, credentials, changeEventFilter, logoutUser} = this.props;
    return (
      <div className="container">
        <MALogo showHelp={true} showLogout={true} onLogoutClick={() => logoutUser()} />
        <WelcomeHeader name={firstName} />
        <NewRequestButton />
        <BuyNowOption />
        <CredentialsSummary credentials={credentials} />
        <Events events={events} changeEventFilter={changeEventFilter} />
      </div>
    )
  }
}

const mapStateToProps = (state) => (
  {
    firstName: state.user.firstName,
    events: state.events,
    credentials: state.credentials,
  }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ changeEventFilter, setUserInfo, setInfoForDashboard, logoutUser }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js